import Masonry from "masonry-layout";
/* Example: https://codesandbox.io/s/collection-grid-toggle-scale-y5bv3d?file=/pages/_app.js */
const ROW_SIZE_DESKTOP = 8;
const ROW_SIZE_MOBILE = 4;

export function init() {
  const msnry = new Masonry(".grid", { percentPosition: true });
  const container = document.querySelector(".lookbook-content-container-v4");

  container.style.opacity = "1";
  const handleClick = (event) => {
    /* window.scrollTo({
      top: event.target.parentElement.offsetTop + event.target.offsetTop,
      behavior: "smooth",
    }); */
    const bigItems = Array.from(document.querySelectorAll(".item-big"));
    bigItems.forEach((item) => {
      item.classList.remove("item-big");
    });
    // Make item big
    event.target.classList.toggle("item-big");

    // Update image
    const img = event.target.querySelector("img");
    // size divided by number of columns the big image should take
    const rowSize = () =>
      window.innerWidth < 640 ? ROW_SIZE_MOBILE / 4 : ROW_SIZE_DESKTOP / 2;
    const updatedImageWidth = Math.round(window.innerWidth / rowSize());
    // using src from the dataset prevents white screen while changing the src
    let currentSrc = img.dataset.imageSource;
    img.removeAttribute("srcset");
    let newSrc = currentSrc.concat(`&width=${updatedImageWidth}`);
    let newSrcRetina = currentSrc.concat(`&width=${updatedImageWidth * 2}`);
    img.src = newSrc;
    img.srcset = `${newSrc} 1x, ${newSrcRetina} 2x`;

    // ?
    if (msnry) {
      msnry.layout();
    }
  };
  const items = Array.from(container.querySelectorAll(".item"));
  for (let item of items) {
    item.addEventListener("click", handleClick);
  }
}
